import { useAcceso } from "./shared";

// Roles de la plataforma de administración. El número es el accesotipo de la
// API (utils/acceso.js). El rol decide a qué plataforma entra el usuario; qué
// puede hacer adentro lo deciden sus permisos (usePermiso / ConPermiso de
// shared, espejo de utils/permisos.js de la API).
export const ROL = {
  ADMINISTRADOR: 21,
  TECNICO: 25,
  CONTABLE: 26,
  ADMINISTRADOR_TECNICO: 27,
  TABLERO: 28,
  SUPER_USER: 29
};

// Todos los roles que entran a la plataforma de administración.
export const ROLES_ADMIN = Object.values(ROL);

// El rol de colaborador entra a otra plataforma; acá solo hace falta para
// reconocer ese acceso al gestionar los de un usuario.
export const ROL_COLABORADOR = 11;

// Lo que todavía depende del rol y no de un permiso.
export const PERMISO = {
  // Roles a los que se les puede asignar un paso de una actividad
  TENER_PASOS_ASIGNADOS: [ROL.SUPER_USER, ROL.ADMINISTRADOR_TECNICO, ROL.TECNICO]
};

/** Rol (accesotipo) del usuario logueado; null mientras no se sabe. */
export function useRol() {
  return useAcceso().accesoTipo;
}

/**
 * Muestra su contenido solo a esos roles. Mientras el rol no se sabe no
 * muestra nada; si el rol no alcanza, muestra `alternativa`.
 */
export function SoloRoles({ roles, alternativa = null, children }) {
  const rol = useRol();
  if (rol === null) return null;
  return roles.includes(rol) ? children : alternativa;
}
